export default function MapSection() {
  return (
    <section className="py-14 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#535669] mb-3 md:mb-4">
            Our Service Area
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
            We proudly serve Sydney and surrounding areas with fast, reliable electrical services.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="aspect-[16/9] w-full">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d424143.47488690634!2d150.65176935!3d-33.847927!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b129838f39a743f%3A0x3017d681632a850!2sSydney%20NSW%2C%20Australia!5e0!3m2!1sen!2s!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Urban Connect Electrical Service Area"
            ></iframe>
          </div>
        </div>

        <div className="mt-8 md:mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <div className="bg-white p-6 md:p-8 rounded-xl shadow-lg text-center">
            <div className="w-12 h-12 md:w-16 md:h-16 bg-[#f67f19] rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
              <i className="ri-map-pin-fill text-2xl md:text-3xl text-white"></i>
            </div>
            <h3 className="text-lg md:text-xl font-bold text-[#535669] mb-2">Service Area</h3>
            <p className="text-sm md:text-base text-gray-600">
              Sydney Metro &amp; Greater Sydney Region
            </p>
          </div>

          <div className="bg-white p-6 md:p-8 rounded-xl shadow-lg text-center">
            <div className="w-12 h-12 md:w-16 md:h-16 bg-[#f67f19] rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
              <i className="ri-time-fill text-2xl md:text-3xl text-white"></i>
            </div>
            <h3 className="text-lg md:text-xl font-bold text-[#535669] mb-2">Fast Response</h3>
            <p className="text-sm md:text-base text-gray-600">
              Same-day service available for most areas
            </p>
          </div>

          <div className="bg-white p-6 md:p-8 rounded-xl shadow-lg text-center">
            <div className="w-12 h-12 md:w-16 md:h-16 bg-[#f67f19] rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
              <i className="ri-shield-check-fill text-2xl md:text-3xl text-white"></i>
            </div>
            <h3 className="text-lg md:text-xl font-bold text-[#535669] mb-2">Licensed &amp; Insured</h3>
            <p className="text-sm md:text-base text-gray-600">
              Fully qualified electricians you can trust
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}